import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const monthlyReportsImporterSelectors = importerSelectors(
  'monthlyReports.importer',
);

export default monthlyReportsImporterSelectors;
